// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App root — fills viewport; scroll lives inside AppShell main content */
.App {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

/* Auth screens scroll within their own column */
.auth-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner svg {
  animation: spin 1s linear infinite;
}

.ml-1 {
  margin-left: 0.25rem;
}

.ml-2 {
  margin-left: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* App root — fills viewport; scroll lives inside AppShell main content */\n.App {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n/* Auth screens scroll within their own column */\n.auth-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  min-height: 0;\n  width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading-spinner svg {\n  animation: spin 1s linear infinite;\n}\n\n.ml-1 {\n  margin-left: 0.25rem;\n}\n\n.ml-2 {\n  margin-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
